import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Briefcase, Search } from "lucide-react";
import { api } from "@/lib/apiClient";
import { Loader, EmptyState } from "@/components/common";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

export default function Jobs() {
  const [data, setData] = useState(null);
  const [cats, setCats] = useState([]);
  const [cat, setCat] = useState("");
  const [page, setPage] = useState(1);

  useEffect(() => { api.get("/job-categories").then((r) => setCats(r.data)); }, []);
  useEffect(() => {
    const q = new URLSearchParams({ page, limit: 12 });
    if (cat) q.set("category", cat);
    api.get(`/jobs?${q}`).then((r) => setData(r.data));
  }, [cat, page]);

  return (
    <div>
      <div className="mb-6">
        <h1 className="font-heading text-3xl sm:text-4xl font-bold">Job Board</h1>
        <p className="text-muted-foreground mt-2">Hand-picked Upwork opportunities analyzed by Coach Reyland.</p>
      </div>

      {cats.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-6">
          <button onClick={() => { setCat(""); setPage(1); }} className={`px-4 py-1.5 rounded-full text-sm font-medium ${!cat ? "bg-teal text-white" : "bg-white border border-border"}`} data-testid="cat-all">All</button>
          {cats.map((c) => (
            <button key={c.id} onClick={() => { setCat(c.name); setPage(1); }} className={`px-4 py-1.5 rounded-full text-sm font-medium ${cat === c.name ? "bg-teal text-white" : "bg-white border border-border"}`} data-testid={`cat-${c.id}`}>{c.name}</button>
          ))}
        </div>
      )}

      {!data ? <Loader /> : data.items.length === 0 ? (
        <EmptyState icon={Briefcase} title="No jobs yet" description="Coach Reyland adds hand-picked Upwork opportunities regularly. Check back soon!" testId="jobs-empty" />
      ) : (
        <>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {data.items.map((j) => (
              <Link to={`/jobs/${j.id}`} key={j.id} className="bg-white border border-border rounded-2xl p-6 shadow-sm hover:-translate-y-1 hover:shadow-md transition-transform" data-testid={`job-card-${j.id}`}>
                <div className="flex items-start justify-between gap-2">
                  <h3 className="font-heading font-semibold">{j.title}</h3>
                  {j.featured && <span className="text-xs text-warning font-semibold shrink-0">★</span>}
                </div>
                {j.category && <Badge variant="secondary" className="mt-2">{j.category}</Badge>}
                <p className="text-sm text-teal font-medium mt-2">{j.rate}</p>
                <p className="text-sm text-muted-foreground mt-2 line-clamp-3">{j.summary}</p>
              </Link>
            ))}
          </div>
          {data.pages > 1 && (
            <div className="flex items-center justify-center gap-2 mt-8">
              <Button variant="outline" size="sm" className="rounded-full" disabled={page <= 1} onClick={() => setPage((p) => p - 1)} data-testid="jobs-prev">Previous</Button>
              <span className="text-sm text-muted-foreground">Page {page} of {data.pages}</span>
              <Button variant="outline" size="sm" className="rounded-full" disabled={page >= data.pages} onClick={() => setPage((p) => p + 1)} data-testid="jobs-next">Next</Button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
